export const breadcrumb = {
    title: "Visualiser mon activité",
    subtitle: "Ouvrir le panneau de sous-menu / recherche",
    dashboard: "Dashboard",
    text: "Sous-menu / recherche"
}